<template>
  <CRow>
    <CCol lg="12">
      <CCard>
        <CCardHeader>
          <strong>Quản lý giao hàng</strong>
          <div class="card-header-actions">
            <CButton type="button" shape="pill" color="info" @click="exportXls">
              <CIcon name="cil-cloud-download"/>
              Xuất xls</CButton>

            <CButton v-if="allowCreate" type="button" shape="pill" color="info" @click="createNew">
              <CIcon name="cil-plus"/>
              Thêm mới</CButton>

            <CButton type="button" shape="pill" color="secondary"
                     class="ml-1 mr-1" style=" width: 100px;"
                     @click="goBack">
              <CIcon name="cil-chevron-left"/>
              Quay lại</CButton>
          </div>
        </CCardHeader>
        <CCardBody class="pt-0">
          <CDataTable
            :items="delivers"
            :fields="fields"
            :tableFilter="{label :'Bộ lọc: ', placeholder:'Nội dung' }"
            :itemsPerPageSelect="{label:' ', values: ['50', '200', '500']}"
            :items-per-page="50"
            column-filter
            hover
            sorter
            clickable-rows
            pagination
            @row-clicked="editRecord"
            @filtered-items-change="setCurrentItems"
          >
            <template #no-items-view>
              <div style="color: #888; text-align: center; padding: 10px; font-style: italic;">
                Danh sách trống!
              </div>
            </template>
            <template #stt="{item, index}">
              <td class="py-2">
                {{index+1}}
              </td>
            </template>
            <template #quantity="{item}">
              <td class="py-2 text-right">
                {{formatNumber(item.quantity)}}
              </td>
            </template>
          </CDataTable>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
export default {
  data() {
    return {
      allowCreate: false,
      // Define the table fields
      fields: [
        { key: 'stt', label: 'Stt', _style:'width:3rem;' },
        { key: 'product', label: 'Tên sản phẩm', _classes: 'font-weight-bold' },
        { key: 'project', label: 'Lô sản xuất' },
        { key: 'bill', label: 'Biên bản BG' },
        { key: 'customer', label: 'Khách hàng' },
        { key: 'quantity', label: 'Số lượng', _style: 'width:6rem; text-align: center;' },        
        { key: 'date', label: 'Ngày giao' },
        { key: 'location', label: 'Địa điểm' },
        { key: 'note', label: 'Ghi chú' },
        { key: 'updated', label: 'Cập nhật' },
      ],
      // Example data
      delivers: [],
      withProject: '',
      withList: '',
      currentItems: [],
    };
  },
  created() {
    this.withProject = this.$route.query.project;
    this.withList = this.$route.query.list;
    this.getAll(this.withProject, this.withList);
  },
  methods: {
    getAll(project, list) {
      if (project) {
        this.$request('/api/device/deliver/project', {
          params: { project: project }
        }).then(res => {
          // console.log(res.data)
          this.delivers = res.data.delivers
        })
      } else if(list) {
        this.$request(`/api/device/deliver/guarantee/${list}`).then(res => {
          // console.log(res.data)
          this.delivers = res.data.delivers
        })
      } else {
        this.$request('/api/device/deliver').then(res => {
          // console.log(res.data)
          this.delivers = res.data.delivers
        })
      }
    },
    editRecord(item, index) {
      // console.log('Edit record:', item);
      this.$router.push({
        path: `/device/deledit`,
        query: {
          id: item.id,
        },
      })
    },
    createNew() {
      this.$router.push({
        path: '/device/deledit',
      })
    },
    goBack() {
      this.$router.go(-1)
    },
    exportXls() {
      this.$swal.fire({
        title: "Xuất ra tệp excel?",
        showDenyButton: false,
        showCancelButton: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.$request.post(`/api/device/delexport`, this.currentItems).
          then(res => {
            if(res.data.status === 'success') {
              this.downloadFile(res.data.filename)
            } else {
              this.$swal.fire({
                icon: "error",
                title: "Xuất ra tệp excel",
                html: "lỗi: "+ res.data.status,
              });
            }
          })
        }
      });
    },
    setCurrentItems (val) {
      this.currentItems = val
    },
    downloadFile(fileName) {
      // console.log('downloadFile', fileName)
      this.$request.get(`/api/repo/downloadbill/${fileName}`, { responseType: 'blob' })
        .then(response => {
          const fileURL = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = fileURL;
          link.download = fileName;
          link.click();
          window.URL.revokeObjectURL(fileURL);
          // document.body.removeChild(link); // Clean up
        })
        .catch(error => {
          console.error('Error downloading the file:', error);
        });
    },
  }
};
</script>
